const fr: Record<string, string> = {
  'features.guitarTuner.startMic': 'Démarrer',
  'features.guitarTuner.stopMic': 'Arrêter',
  'features.guitarTuner.requesting': 'Demande du micro…',
  'features.guitarTuner.micDenied': 'Accès au microphone refusé. Veuillez autoriser l\'accès et réessayer.',
  'features.guitarTuner.flat': 'Trop bas — serrer',
  'features.guitarTuner.sharp': 'Trop haut — desserrer',
  'features.guitarTuner.inTune': '✓ Accordé',
  'features.guitarTuner.string': 'Corde',
};

export default fr;
